import axios from "../utils/axiosConfig";

// Fetch test data with automatic retry on failure.
// Retries 3 times with exponential back-off (3 s → 6 s → 12 s).
// This handles the case where the server is momentarily overloaded (e.g. at exam
// start when many users hit the endpoint simultaneously and the first request warms
// the Redis cache for all subsequent ones).
const fetchTestDataWithRetry = async (bodyObj, maxRetries = 3) => {
  let attempt = 0;
  while (attempt <= maxRetries) {
    try {
      return await axios.post('/test/userTest', bodyObj);
    } catch (err) {
      if (attempt === maxRetries) throw err;
      const delayMs = Math.pow(2, attempt) * 3000; // 3 s, 6 s, 12 s
      console.log(`[userTest] Attempt ${attempt + 1} failed, retrying in ${delayMs / 1000}s…`);
      await new Promise(resolve => setTimeout(resolve, delayMs));
      attempt++;
    }
  }
};

const modalHandler = async(row,index,name,props,setLoading,setModelShow,setMsgModal,setResumeLoader,setMessageModal,setMessage,setCodeLanguages,selectedLanguage) => {
    const {setExamId,setTestData,setModal} = props;
    setLoading({index:index,status:true,name:name}); 
    setResumeLoader({index:index,status:true,name:name});
    setExamId(row.userExamId);
    let decode;
    let _timeRemaining;
    // if(window.localStorage.getItem(row.userExamId) !== null){
    // decode = decodeURIComponent(atob(decodeURIComponent(window.localStorage.getItem(row.userExamId))))}
    // else {
    // Only remove specific exam-related data, preserve pending test submissions (test-submit-*, test-data-pending-*)
    window.localStorage.removeItem(row.userExamId);
    window.localStorage.removeItem("remainingTime");
    await axios.post('/test/answeredQts',{
        headers: {
            'Access-Control-Allow-Origin': '*',
          },   id: row.userExamId
      }).then((examData) => {
        if(examData.data.result.length > 0) {
         window.localStorage.setItem(row.userExamId,examData.data.result)
         let decodedData = decodeURIComponent(atob(decodeURIComponent(examData.data.result)))
          let decodedString = JSON.stringify(decodedData)
         let parsedDecode = JSON.parse(decodedString)
          decode = parsedDecode;
          _timeRemaining = JSON.parse(decode)[0] && JSON.parse(decode)[0].examDetail[0] && JSON.parse(decode)[0].examDetail[0].time_remaining;
          // setTestData({quesData: JSON.parse(decode)[0].quesData,examDetail:JSON.parse(decodedData)[0].examDetail});
        }
      })
    // }
    if(decode){
      decode = JSON.stringify(decode);
      decode = JSON.parse(decode);
      var parsedExamData = JSON.parse(decode);      
      setTestData({quesData : parsedExamData.quesData,examDetail : parsedExamData.examDetail});
      setModal(true);
    }
  
    // if(decode === null || decode === '[object Object]' || decode === undefined){
    //if(!window.localStorage.getItem(row.userExamId)){
      
    let bodyObj = decode !== undefined ? {
      headers: {
          'Access-Control-Allow-Origin': '*',
        },  examId: row.userExamId, remainingTime: parsedExamData[0] ? parsedExamData[0].examDetail[0].time_remaining : parsedExamData.examDetail[0].time_remaining, selectedLanguage
    } : {
      headers: {
        'Access-Control-Allow-Origin': '*',
      },  examId: row.userExamId, selectedLanguage
    }
    let statusMessage
    if(decode === null || decode === '[object Object]' || decode === undefined){
    fetchTestDataWithRetry(bodyObj).then(testData => {
     
      // console.log('testData====>', testData);
      if (testData.data) {
        statusMessage = testData.data.msg === "SUCCESS" ? undefined : testData.data.msg
      }
      // React 18: Validate examDetail before setting state (prevents concurrent rendering issues)
      const isExamDetailValid = testData.data.examDetail && Array.isArray(testData.data.examDetail) && testData.data.examDetail.length > 0;
      
      if (!isExamDetailValid) {
        setMsgModal(true);
        setModelShow(true);
        setMessageModal(testData.data.msg || "Unable to load test data. Please try again.");
        setLoading({status:false,index:"",name:''});
        setResumeLoader({index:'',status:false,name:''});
        return;
      }

      if(testData.data.quesData !== undefined) {
      let decodeQuesData  = decodeURIComponent(atob(decodeURIComponent(testData.data.quesData)))
      if(decode === null || decode === '[object Object]' || decode === undefined){        
      setTestData({quesData: JSON.parse(decodeQuesData), examDetail: testData.data.examDetail});
      }else{
      setTestData({quesData: JSON.parse(decode).quesData, examDetail: JSON.parse(decode).examDetail})
      }}
      else if(testData.data.quesData === undefined){
        setMsgModal(true);
        setModelShow(true);
        setMessageModal(testData.data.msg);
        setLoading({status:false,index:"",name:''});
        setResumeLoader({index:'',status:false,name:''});
        return;
      }
      let collectData = {quesData: testData.data.quesData, examDetail: testData.data.examDetail}
      let encode = encodeURIComponent(btoa(encodeURIComponent(JSON.stringify(collectData))))
            
              if(testData.data.examDetail !== undefined) {
      if(testData.data.examDetail[0].status === '000'){
        window.localStorage.setItem(row.userExamId, encode)
      }
    }
      setModal(true);
      setLoading({status:false,index:"",name:''})
      setResumeLoader({index:'',status:false,name:''})
    }).catch(error => {
      console.log('error====>', error);
      // Ensure local storage is cleared if backend retrieval fails
      window.localStorage.removeItem(row.userExamId);
      
      setMessageModal('System Warning')
      if (statusMessage) {
        setMessage(statusMessage)
      }
      else {
        setMessage('Connectivity with the server has been lost. Please retry after some time.');
      }
      setMsgModal(true);
      setModelShow(true);
    })
    }
    // }else{
    //   setTestData(JSON.parse(decode));
    //   //setTestData(window.localStorage.getItem(row.userExamId));
    //   setModal(true);
    // }   
    await axios.get('/test/programlanguages',{
      headers: {
          'Access-Control-Allow-Origin': '*',
        }
    }).then((result) => { 
      setCodeLanguages(result.data)
    })
  }

export default modalHandler